<template>
  <div>
    <span 
      v-if="popular" 
      class="popular">Most Popular</span>
    <span class="months">{{ months }}</span>
    <span class="text">months</span>
    <span class="price">{{ price/100 }}</span>
  </div>
</template>
<script>
export default {
    props: {
        popular: {
            type: Boolean,
            required: false,
            default: false
        },
        months: {
            type: Number,
            required: true
        },
        price: {
            type: Number,
            required: true
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/modals/RegimenChecker/steps/PackageItem.vue